// extracted by mini-css-extract-plugin
export default {"deniedTileValueBadge":"DeniedTile_deniedTileValueBadge__kh0Ej"};